import React, { useState, useEffect, useRef, Fragment } from "react";
import classnames from "classnames";
import NumberFormat from "react-number-format";
import Skeleton from "react-loading-skeleton";
import axiosInstance from "./../../helpers/axiosInstance";
import MyModal from "components/Modal/Modal";
import santander from '../../assets/img/brand/santander.png';
import exitoCreacion from '../../assets/img/illustrations/add-contact-success.svg';
import ComponentemodificaUsu from './modificaUsuario.js'
import Cuadricula from './Domiciliacioncomp/Cuadricula.js'



import IconTid from '../../assets/img/icons/Icono-Tipo-de-documento-Gris.png'


import icon_Administras_usuarios from 'assets/img/icons/Icono-Administrar-Usuarios-Gris.png'
import icon_Administras_usuariosA from 'assets/img/icons/Icono-Administrar-Usuarios-Rojo.png'


// reactstrap components
import {
  Card,
  CardBody,
  CardTitle,
  Container,
  Row,
  Col,
  Modal,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  CardHeader,
  Button,
  FormGroup,
  InputGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import { normalizeUnits } from "moment";
import { tr } from "date-fns/locale";
import basePerfiles from "./basePerfiles.js";
import baseUsuarios from "./baseUsu.js";
import { set } from "date-fns";
import baseTransaccionPen from "./baseTransaccionesPen.js";
import Compotp from "./Compotp";
import Checksantader from "./Checksantander";
import Confirmmodal from "./Confirmmodal";
import perf from "./basePerfiles.js";
import IconNid from '../../assets/img/icons/Icono-Numero-documento-Gris.png';
import IconCorreo from '../../assets/img/icons/Icono-Correo-Gris.png';
import IconNom from '../../assets/img/icons/Cliente-Gris2x.png';
import IconCel from '../../assets/img/icons/Telefono-Gris2x.png';
import IconPesos from '../../assets/img/icons/Tope_Monto_Transaccional-Gris2x.png';
import IconMas from '../../assets/img/icons/circulo-mas.png';
import IconMasRojo from '../../assets/img/icons/circulo-mas-Rojo.png';
import IconEliminar from '../../assets/img/icons/IconoEliminar.png';
import IconEliminarRojo from '../../assets/img/icons/iconoEliminarRojo.png';

import BotonEliminaIp from "./botoneliminarIp";
import Campoformato from "./campoformato";
import { event } from "jquery";
import {useDispatch} from "react-redux";
import {cambiaruta,cambiasidebar} from "../../Slicersreducers";
import CalendarioNuevo from "./CalendarioNuevo";
import Formetapa1 from "./Domiciliacioncomp/formetapa1.js";
import { flatMap } from "lodash";
//import { Console } from "console";
const _=require("lodash");

const Domiciliacion=(props)=>{
    var tabsAux = 0;
    var accountAux = {};
    var createReactClass = require("create-react-class");
    const [listAlert,setlistAlert]=useState([]);
    const [tabs, setTabs] = useState(tabsAux);
    const [stepLine, setstepLine] = useState(0);
    const listStepLine = [
        { title: "Nueva condición de asociación" },
        { title: "Producto de origen" },
        {title:"Producto destino"},
        { title: "Periodicidad" },
      ];
    const [maxstepcreaUsu,setmaxstepcreaUsu]=useState(0); //* en el useeffect
    const [step, setStep] = useState(0);
    const [infoModal, setInfoModal] = useState(false);
    const [infoPeriodicity, setInfoPeriodicity] = useState(false);
    const [infoPeriodicityMont, setInfoPeriodicityMont] = useState(false);
    const [mostrar,setmostrar]=useState(true);
    const [checkunica,setcheckunica]=useState(false);//* en el useeffect
    const [checkdiaria,setcheckdiaria]=useState(false);//* en el useeffect
    const [checksemanal,setchecksemanal]=useState(false);//* en el useeffect
    const [checkmensual,setcheckmensual]=useState(false);//* en el useeffect
    const dispatch=useDispatch();
    const [relatedAccounts, setRelatedAccounts] = useState([]);
    const [isLoadingAccounts, setIsLoadingAccounts] = useState(true);
    const [accountsToTransfer, setAccountsToTransfer] = useState([]);
    const [productOne, setProductOne] = useState(accountAux);//*
    const [productTwo, setProductTwo] = useState();//*
    const [accounts, setAccounts] = useState([]);
    const [weekDay, setWeekDay]=useState("");//* en el useeffect
    const [montDay, setMontDay]=useState("");//* en el useeffect
    
    const [desdom, setdesdom]=useState("");//*
    const [tipope,settipope]=useState("1");//*
    const [arrtip,setarrtip]=useState([true,false,false]);//* en el useeffect
    const [valasoc,setvalasoc]=useState("");//*
    const [tipoproddesti,settipoproddesti]=useState(0);//*

    const [fechaselec,setfechaselec]=useState("");//*
    const [isLoading, setIsLoading] = useState(false);

    const [condicioncomision,setcondicioncomision]=useState("");
    const [secuencia,setsecuencia]=useState("");
    const [statusdomi,setstatusdomi]=useState("");
    const [tipoflujo,settipoflujo]=useState(props.flujo);
    const [frecuanciadom,setfrecuanciadom]=useState("");
    const [clasestarjetasprodorig,setclasestarjetasprodorig]=useState([]);
    const [clasestarjetasproddest1,setclasestarjetasproddest1]=useState([]);
    const [clasestarjetasproddest2,setclasestarjetasproddest2]=useState([]);
    const [clasestarjetasproddest3,setclasestarjetasproddest3]=useState([]);

    const inicializaestados=()=>{
      console.log("inicializa modificacion domi");
      console.log(props.dataini)
      /*
      objeto que viene de la asociacion para modificar
      {
        "associationSecuence": "1",
        "status": "1",
        "commissionCondition": "PRUEBA",
        "operationType": "1",
        "originSystem": 20,
        "originProduct": "00000014400487077",
        "periodicity": "1",
        "weekDay": "",
        "dayMonthApliaction": "",
        "applicationDate": "20221214",
        "destinationSystem": 20,
        "destinationProduct": "00000000100489461",
        "externalAccountSecuenceNumber": "",
        "transferValue": "450.00",
        "associationDescription": "primer flujo domiciliacion"
      } */
      setsecuencia(props.dataini.associationSecuence);
      setcondicioncomision(props.dataini.commissionCondition);
      setstatusdomi(props.dataini.status);
      setmaxstepcreaUsu(3); //* en el useeffect
      switch(props.dataini.periodicity){
        case "1":
          setcheckunica(true);
          setfechaselec(props.dataini.applicationDate);
          break;
        case "2":
          setcheckdiaria(true)
          setfechaselec(props.dataini.applicationDate);
            break;
        case "3":
          setchecksemanal(true)
          setWeekDay(props.dataini.weekDay)
          break;
        case "4":
          setcheckmensual(true)
          setMontDay(props.dataini.dayMonthApliaction)
          break;
      }

      setProductOne({accountNumber:props.dataini.originProduct,
                    system:props.dataini.originSystem
      });//*

      if(props.dataini.externalAccountSecuenceNumber.length>0){
        setProductTwo({
          numeroCuenta:props.dataini.destinationProduct,
          sequence:props.dataini.externalAccountSecuenceNumber
        });//*
        settipoproddesti(2);//*
      }else{
        setProductTwo({
          accountNumber:props.dataini.destinationProduct,
          system:props.dataini.destinationSystem
        });//*
        settipoproddesti(1);//*
      }
    
      setdesdom(props.dataini.associationDescription);//*
      settipope(props.dataini.operationType);//*
      let arrtipoepracion=[false,false,false];
      if(Number(props.dataini.operationType)>0 && Number(props.dataini.operationType)<=3){
        arrtipoepracion[Number(props.dataini.operationType) - 1]=true;
      }
      setarrtip(arrtipoepracion);//* en el useeffect
      setvalasoc(props.dataini.transferValue);//*
    }

    

    const convertirfecha = (fecha400)=>{
      let newFecha="";
      let diasSemana=["Domingo","Lunes","Martes","Miercoles","Jueves","Viernes","Sabado"];
      let meses=["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];
      if(fecha400.length==8){
        newFecha=fecha400.substr(-2,2) + " de " + meses[Number(fecha400.substr(4,2))-1] + " del " + fecha400.substr(0,4);
      }
      return newFecha;
    }
    const deleteAlert = (alert) => {

        console.log("elimina alerta");
        console.log(listAlert);
        setlistAlert(listAlert.filter((auxAlert) => auxAlert != alert));
      };
    const asignafecha =(valor) =>{
      console.log ("valorparametro"+ valor);
      switch (valor)
      {
        case 0:
          setWeekDay("L");          
          break;
        case 1:
          setWeekDay("M");          
          break;
        case 2:
          setWeekDay("X");          
          break;
        case 3:
          setWeekDay("J");          
          break;
        case 4:
          setWeekDay("V");          
          break;
        case 5:
          setWeekDay("S");          
          break;
        case 6:
          setWeekDay("D");          
          break;
      }
        console.log ("asignafecha:" + valor  + "-" +  weekDay);
        setInfoPeriodicity(false);
    }  
    const asignafechames =(valor) =>{
      console.log ("valorasignafechames"+ valor);
      
          setMontDay((valor+1) + "");
          
        console.log ("asignafechames:" + valor  + "-" +  montDay);
        setInfoPeriodicityMont(false);
    }  
    var Products = createReactClass({
        render: function () {
          var data = this.props.data;
          var tab = this.props.tab;
          var isOrigin = this.props.isOrigin;
          var newsTemplate;
    
          if ((data.length > 0)) {
            newsTemplate = data.map(function (item, index) {
              if (isOrigin) {
                return (
                  <Row key={index} onClick={() => getProductOrigin(item, tab,index)}>
                    <CardAccount data={item} claseprod={clasestarjetasprodorig[index]} />
                  </Row>
                )
              } else {
                switch(tipope){
                  case "1":
                    return (
                      <Row key={index} onClick={() => getProductDestiny(item, tab,index)}>
                        <CardAccount data={item} claseprod={clasestarjetasproddest1[index]} />
                      </Row>
                    )
                    break;
                  case "2":
                    return (
                      <Row key={index} onClick={() => getProductDestiny(item, tab,index)}>
                        <CardAccount data={item} claseprod={clasestarjetasproddest2[index]} />
                      </Row>
                    )
                    break;
                  case "3":
                    return (
                      <Row key={index} onClick={() => getProductDestiny(item, tab,index)}>
                        <CardAccount data={item} claseprod={clasestarjetasproddest3[index]} />
                      </Row>
                    )
                    break;   
                }
                
              }
            })
          } else {
            console.log("no tiene productos destino");
            newsTemplate = <Skeleton height={100} count={4} className="card-transaction-info" style={{ width: "-webkit-fill-available" }}></Skeleton>
          }
          return (
            <div>
              {newsTemplate}
            </div>
          );
        }
      });
      var CardAccountContact = createReactClass({
        render: function () {
          var aliasAccount = this.props.data.aliasAccount,
            numeroCuenta = this.props.data.numeroCuenta;
          return (
            <Col lg="12" xl="12" className="pt-3">
              <Card className="mb-xl-0 cursor-pointer bordeHover">
                <CardBody className="">
                  <Row>
                    {/* <div className="col-auto vertical-center">
                      <Row className="m-4">
                        <i className="fas fa-money-bill text-green" />
                      </Row>
                    </div> */}
                    <div className="col ml-4">
                      <Row>
                        <span class="mt-1 text-sm h4">{aliasAccount}</span>
                      </Row>
                      <Row>
                        <span class="mt-0 mb-0 text-sm">Cuenta No. {numeroCuenta}</span>
                      </Row>
                      <Row>
                        <span class="mb-1 text-sm"></span>
                      </Row>
                    </div>
                    {/* <div className="col-auto mr-3 vertical-center">
                      <Row className="m-4">
                        <a className="button"><i className="fas fa-chevron-right" /></a>
                      </Row>
                    </div> */}
                  </Row>
                </CardBody>
              </Card>
            </Col>
          );
        }
      });
      async function getContact(product) {
        await setProductTwo(product);
        settipoproddesti(2);
        
        await AvanzaStep(3);
      }
      var RelatedAccounts = createReactClass({
        render: function () {
          var data = this.props.data;
          var newsTemplate;
         console.log("cuentas asociadas" + data.length)
          if (data.length > 0) {
            newsTemplate = data.map(function (item, index) {
              return (
                <Row key={index} onClick={() => getContact(item)}>
                  <CardAccountContact data={item} />
                </Row>
              )
            })
          } else if (isLoadingAccounts) {
            newsTemplate = <Skeleton height={100} count={4} className="card-transaction-info" style={{ width: "-webkit-fill-available" }}></Skeleton>
          } else {
            newsTemplate = <div className="text-center m-4">
              <h2 class="ml-2"> No cuentas con Cuentas Asociadas </h2>
            </div>;
          }
          return (
            <div>
              {newsTemplate}
            </div>
          );
        }
      });
        
      useEffect(async() => {
        let arrclases=[];
        let numberaccount=[];
        async function getProducts() {
          setIsLoading(false);
          const request = await axiosInstance().get("/WSGYG39_2/api/Inquiries/Products/Accounts")
            .catch(err => {
              console.log(err);
              if (err.response.data.errors) {
                setlistAlert(
                  err.response.data.errors.map((o) => ({
                    ...o,
                    type: "alert alert-alert show alert-dismissible fade alert-danger",
                    icon: "fas fa-exclamation-circle",
                  }))
                );
              } else {
                setlistAlert([
                  {
                    description: "No se pudo realizar el registro.",
                    type: "alert alert-alert show alert-dismissible fade alert-danger",
                    icon: "fas fa-exclamation-circle"
                  }
                ]);
              }
              cancelaUsuCM();
              return 'err';
            });
          if (request != 'err') {
            console.log("se consume el accounts domiciliacion");
            setIsLoading(false);
            console.log(request.data);
            console.log(request.data.summaryProduct.product);
            setAccounts(request.data.summaryProduct.product);
            
            request.data.summaryProduct.product.map(item=>{arrclases.push("mb-xl-0 cursor-pointer bordeHover")
            numberaccount.push(item.accountNumber)})
            setclasestarjetasprodorig([...arrclases]);
            if(tipoflujo=="modificadomi"){
              getRelatedAccountsmodifica(request.data.summaryProduct.product);
            }
          }
          return request;
        }
        await getProducts();
        console.log("tipo de flujo domi " + tipoflujo)
        if(tipoflujo=="modificadomi"){
          inicializaestados();
          let numberprodorig=props.dataini.originProduct;
          let posprodorig= numberaccount.indexOf(numberprodorig);
          if(posprodorig>=0){
            arrclases[posprodorig]="mb-xl-0 cursor-pointer bordeHover productoselec";
            setclasestarjetasprodorig([...arrclases]);
          }
          
        }
      }, []);

      async function getRelatedAccounts(accountNumber) {
        /*/WSGYG39_2/api/Inquiries/Products/Loans*/
        setIsLoading(false);
        setIsLoadingAccounts(true);
        let arrproddest=[];
        let arrproddest2=[];
        await setStep(s => s + 1);
        if(tipope=="3"){
          const request = await axiosInstance().get("/WSGYG39_2/api/Inquiries/Products/Loans")
            .catch(err => {
              console.log(err);
              if (err.response.data.errors) {
                setlistAlert(
                  err.response.data.errors.map((o) => ({
                    ...o,
                    type: "alert alert-alert show alert-dismissible fade alert-danger",
                    icon: "fas fa-exclamation-circle",
                  }))
                );
              } else {
                setlistAlert([
                  {
                    description: "No se pudo realizar el registro.",
                    type: "alert alert-alert show alert-dismissible fade alert-danger",
                    icon: "fas fa-exclamation-circle"
                  }
                ]);
              }
              setIsLoadingAccounts(false);
              return 'err';
            });
          if (request != 'err') {
            setIsLoading(false);
            setIsLoadingAccounts(false);
            console.log(request.data);
            setRelatedAccounts(request.data.summaryProduct.product);
            request.data.summaryProduct.product.map(item=>{
              if(item.accountNumber != accountNumber){
                arrproddest2.push("mb-xl-0 cursor-pointer bordeHover");
              }
            })
            setclasestarjetasproddest3([...arrproddest2]);

            setclasestarjetasproddest1([...arrproddest]);
            setAccountsToTransfer(accounts.filter(item => !(item.accountNumber === accountNumber)))
            accounts.map(item=>{
              if(item.accountNumber != accountNumber){
                arrproddest.push("mb-xl-0 cursor-pointer bordeHover");
              }
            })
            setclasestarjetasproddest1([...arrproddest]);
          }
          
          return request;
        }else{
          
          const request = await axiosInstance().get("/WSGYG39_2/api/Consultas/AssociatedAccounts")
            .catch(err => {
              console.log(err);
              if (err.response.data.errors) {
                setlistAlert(
                  err.response.data.errors.map((o) => ({
                    ...o,
                    type: "alert alert-alert show alert-dismissible fade alert-danger",
                    icon: "fas fa-exclamation-circle",
                  }))
                );
              } else {
                setlistAlert([
                  {
                    description: "No se pudo realizar el registro.",
                    type: "alert alert-alert show alert-dismissible fade alert-danger",
                    icon: "fas fa-exclamation-circle"
                  }
                ]);
              }
              setIsLoadingAccounts(false);
              return 'err';
            });
          if (request != 'err') {
            setIsLoading(false);
            setIsLoadingAccounts(false);
            console.log(request.data);
            setRelatedAccounts(request.data.relatedAccounts.filter(item => (item.status === null)));
            request.data.relatedAccounts.map(item=>{
              if(item.status === null){
                arrproddest2.push("mb-xl-0 cursor-pointer bordeHover");

              }
            })
            setclasestarjetasproddest2([...arrproddest2]);


            setAccountsToTransfer(accounts.filter(item => !(item.accountNumber === accountNumber)));
            accounts.map(item=>{
              if(item.accountNumber != accountNumber){
                arrproddest.push("mb-xl-0 cursor-pointer bordeHover");
              }
            })
            setclasestarjetasproddest1([...arrproddest]);
          }
          return request;
        }
        
      }
      async function getRelatedAccountsmodifica(listaproductosdest) {
        setIsLoading(false);
        setIsLoadingAccounts(true);
        let arrproddest=[];
        let arrproddest2=[];
        if(tipope=="3"){
          const request = await axiosInstance().get("/WSGYG39_2/api/Inquiries/Products/Loans")
            .catch(err => {
              console.log(err);
              if (err.response.data.errors) {
                setlistAlert(
                  err.response.data.errors.map((o) => ({
                    ...o,
                    type: "alert alert-alert show alert-dismissible fade alert-danger",
                    icon: "fas fa-exclamation-circle",
                  }))
                );
              } else {
                setlistAlert([
                  {
                    description: "No se pudo realizar el registro.",
                    type: "alert alert-alert show alert-dismissible fade alert-danger",
                    icon: "fas fa-exclamation-circle"
                  }
                ]);
              }
              setIsLoadingAccounts(false);
              return 'err';
            });
          if (request != 'err') {
            setIsLoading(false);
            setIsLoadingAccounts(false);
            console.log(request.data);
            setRelatedAccounts(request.data.summaryProduct.product);
            request.data.summaryProduct.product.map(item=>{
              if(item.accountNumber != props.dataini.originProduct){
                if(props.dataini.destinationProduct!=item.accountNumber){
                  arrproddest2.push("mb-xl-0 cursor-pointer bordeHover");
                }else{
                  arrproddest2.push("mb-xl-0 cursor-pointer bordeHover productoselec");
                }
                
              }
            })
            setclasestarjetasproddest3([...arrproddest2]);



            setAccountsToTransfer(listaproductosdest.filter(item => !(item.accountNumber === productOne.accountNumber)));
            listaproductosdest.map(item=>{
              if(item.accountNumber != props.dataini.originProduct){
                if(props.dataini.destinationProduct!=item.accountNumber){
                  arrproddest.push("mb-xl-0 cursor-pointer bordeHover");
                }else{
                  arrproddest.push("mb-xl-0 cursor-pointer bordeHover productoselec");
                }
              }
            })
            setclasestarjetasproddest1([...arrproddest]);
          }else{
            setIsLoadingAccounts(false);
          }
          
          return request;
        }else{
          const request = await axiosInstance().get("/WSGYG39_2/api/Consultas/AssociatedAccounts")
            .catch(err => {
              console.log(err);
              if (err.response.data.errors) {
                setlistAlert(
                  err.response.data.errors.map((o) => ({
                    ...o,
                    type: "alert alert-alert show alert-dismissible fade alert-danger",
                    icon: "fas fa-exclamation-circle",
                  }))
                );
              } else {
                setlistAlert([
                  {
                    description: "No se pudo realizar el registro.",
                    type: "alert alert-alert show alert-dismissible fade alert-danger",
                    icon: "fas fa-exclamation-circle"
                  }
                ]);
              }
              setIsLoadingAccounts(false);
              return 'err';
            });
          if (request != 'err') {
            setIsLoading(false);
            setIsLoadingAccounts(false);
            console.log(request.data);
            setRelatedAccounts(request.data.relatedAccounts.filter(item => (item.status === null)));
            request.data.relatedAccounts.map(item=>{
              if(item.status === null){
                if(item.numeroCuenta!=props.dataini.destinationProduct){
                  arrproddest2.push("mb-xl-0 cursor-pointer bordeHover");
                }else{
                  arrproddest2.push("mb-xl-0 cursor-pointer bordeHover productoselec");
                }
                
              }
            })
            setclasestarjetasproddest2([...arrproddest2]);

            setAccountsToTransfer(listaproductosdest.filter(item => !(item.accountNumber === productOne.accountNumber)));
            listaproductosdest.map(item=>{
              if(item.accountNumber != props.dataini.originProduct){
                if(item.accountNumber !=props.dataini.destinationProduct){
                  arrproddest.push("mb-xl-0 cursor-pointer bordeHover");
                }else{
                  arrproddest.push("mb-xl-0 cursor-pointer bordeHover productoselec");
                } 
              }
            })
            setclasestarjetasproddest1([...arrproddest]);
          
          }else{
            setIsLoadingAccounts(false);
          }
          
          return request;
        }
      }

      var CardAccount = createReactClass({
        render: function () {
          if(this.props.data.accountNumber != undefined){
            var accountNumber = this.props.data.accountNumber,
            balance = this.props.data.balance,
            description = this.props.data.description;
          }else{
            var accountNumber = this.props.data.numeroCuenta.substring,
            balance = "",
            description = this.props.data.ownerAccount;
          }
          
          return (
            
            <Col lg="8" xl="8" className="pt-3 ml-8">
              <Card className={this.props.claseprod}>
                <CardBody className="p-2">
                  <Row>
                    <div onClick={()=> {}} className="col-auto ml-4 p-1" style={{ width: "80%" }}>
                      <Row>
                        <span class="mb-0">{description}<br /> No. {accountNumber}</span>
                      </Row>
                      <Row>
                        <span class="mb-0 text-sm">Disponible <NumberFormat value={balance} displayType={'text'} thousandSeparator={true} prefix={'$'} /></span>
                      </Row>
                    </div>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          
          );
        }
      });

      async function getProductOrigin(product, tab ,index) {
        await setProductOne(product);
        let copiaclasprod=[...clasestarjetasprodorig];
        copiaclasprod[index]="mb-xl-0 cursor-pointer bordeHover productoselec";
        setclasestarjetasprodorig([...copiaclasprod]);
        console.log("tab" + tab)
        getRelatedAccounts(product.accountNumber);
        await AvanzaStep(2);
      }
    
      async function getProductDestiny(product, tab, index) {
        let copiaarrclas;
        
        switch(tipope){
          case "1":
            copiaarrclas=[...clasestarjetasproddest1];
            copiaarrclas[index]="mb-xl-0 cursor-pointer bordeHover productoselec";
            setclasestarjetasproddest1([...copiaarrclas]);
            break;
          case "2":
            copiaarrclas=[...clasestarjetasproddest2];
            copiaarrclas[index]="mb-xl-0 cursor-pointer bordeHover productoselec";
            setclasestarjetasproddest2([...copiaarrclas]);
            break;
          case "3":
            copiaarrclas=[...clasestarjetasproddest3];
            copiaarrclas[index]="mb-xl-0 cursor-pointer bordeHover productoselec";
            setclasestarjetasproddest3([...copiaarrclas]);
            break;
        }
        console.log(copiaarrclas);
        await setProductTwo(product);
        settipoproddesti(1);
        await AvanzaStep(3);
        
      }

    var Alerts = createReactClass({
        render: function () {
          var data = this.props.data;
          var newsTemplate;
          if (data.length > 0) {
            newsTemplate = data.map(function (item, index) {
              return (
                <div class={item.type} role="alert">
                  <button
                    type="button"
                    class="close"
                    aria-label="Close"
                    onClick={() => deleteAlert(item)}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                  <span className="alert-inner--icon mr-3">
                    <i className={item.icon} />
                  </span>{" "}
                  <span class="alert-inner--text">{item.description}</span>
                </div>
              );
            });
          }
          return <div className="toast-bottom-right">{newsTemplate}</div>;
        },
      });

    function DivStepper({ children, ...props }) {
        const childrenArray = React.Children.toArray(children);

        const currentChild = childrenArray[props.step];
        if (props.type === "tab") {
            return (
            <div {...props}>
                <TabStepper
                current={props.step}
                listStep={props.listStep}
                ></TabStepper>
                {currentChild}
            </div>
            );
        } else if (props.type === "line") {
            return (
            <div className="anchosteper" {...props} >
                <NavigationButtons
                tab={props.tab}
                step={props.step}
                listStep={props.listStep}
                ></NavigationButtons>
                <LineStepper
                current={props.step}
                listStep={props.listStep}
                ></LineStepper>
                <div className="text-center m-4">
                <h2 class="ml-2">{props.listStep[props.step].title}</h2>
                </div>
                {currentChild}
            </div>
            );
        } else return <></>;
    }

    function NavigationButtons(props) {
        var isFirst=true;
        if(props.step > 0){
          isFirst=false;
        }
        var isEnd = props.step === props.listStep.length - 1;
        /*onClick={()=>{controlesCreaUsu(stepLine,-1)}}*/
        /*onClick={()=>{controlesCreaUsu(stepLine,1)}}*/
        //disabled={!isEnd}
        //disabled={!isFirst}
        return (
          
          <div style={{ justifyContent: "space-between", display: "flex" }}>
            <button  class="btn-icon text-dark-grey btn ml-7" disabled={isFirst} onClick={()=>{controlesCreaUsu(stepLine,-1)}}>
              <span class="btn-inner--icon">{"<"}</span>
              <span class="btn-inner--text">
                {isFirst ? "Volver" : props.listStep[props.step - 1].title}
              </span>
            </button>
            <button class="btn-icon text-dark-grey btn mr-7" disabled={isEnd} onClick={()=>{controlesCreaUsu(stepLine,1)}}>
              <span class="btn-inner--text">
                {isEnd ? "Cancelar" : props.listStep[props.step + 1].title}
              </span>
              <span class="btn-inner--icon">{">"}</span>
            </button>
          </div>
        );
      }

      function LineStepper(props) {
        return (
          <>
            <div style={{ position: "relative" }} className="mt-1 m-4 mb-6 ml-9">
              <div style={{ position: "absolute", width: "100%" }}>
                <Progress current={props.current} list={props.listStep}></Progress>
              </div>
            </div>
          </>
        )
      }

      function Progress(props) {
        const styleProgress = { width: 80 / props.list.length - 2 + "%" };
        var newsTemplate = props.list.map(function (item, index) {
          if (index === props.current) {
            return (
              <div
                key={index}
                className="progress-bar-step-active"
                style={styleProgress}
              >
                <span className="stepper-number-active">
                  <span className="stepper-label-active">{index + 1}</span>
                </span>
              </div>
            );
          } else {
            return (
              <div key={index} className="progress-bar-step" style={styleProgress}>
                <span className="stepper-number">
                  <span className="stepper-label">{index + 1}</span>
                </span>
              </div>
            );
          }
        });
        return newsTemplate;
      }
      
      function TabStepper(props) {
        var newsTemplate = props.listStep.map(function (item, index) {
          return (
            <Step
              key={index}
              current={props.current}
              step={index}
              label={item.title}
            />
          );
        });
        return (
          <>
            <Row>{newsTemplate}</Row>
          </>
        );
      }
      function Step(props) {
        if (props.current === props.step) {
          return (
            <div
              className="radius-middle active shadow p-3 mt-4 mb-4 text-center text-green cursor-pointer col"
              onClick={() => setStep(props.step)}
            >
              {props.label}
            </div>
          );
        } else {
          return (
            <div
              className="radius-middle shadow p-3 mt-4 mb-4 text-center text-green cursor-pointer col"
              onClick={() => setStep(props.step)}
            >
              {props.label}
            </div>
          );
        }
      }

      function DivStep({ children }) {
        return <>{children}</>;
      }
      const cancelaUsuCM=()=>{
        setmaxstepcreaUsu(0); 
        setstepLine(0);
        props.canceladomi("domiciliacion");   
      }

      const controlesCreaUsu=(etapa,sentido)=>{
        console.log("etapa " + etapa + " sentido " + sentido);
        console.log(maxstepcreaUsu)
        let pasar=true;
        if(sentido==1){
          if(etapa==0){
            pasar=validaform();
          }
          if(etapa+1 <= maxstepcreaUsu && pasar){
              setstepLine((s) => s + 1);
          }
        }else{
          if(etapa-1 >=0){
              setstepLine((s) => s - 1);
          }
        }
      }
    
    const AvanzaStep=(paso)=>{
        setstepLine(paso);
        if(paso>maxstepcreaUsu){
          setmaxstepcreaUsu(paso);
        }
    }
    const AvanzaStepform=(paso,data)=>{
      if(data.desdom.length>0){
        if(data.tipooperacion.length>0){
          if(data.valorasoc.length>0){
            setlistAlert([
            ])
            setstepLine(paso);
            if(paso>maxstepcreaUsu){
              setmaxstepcreaUsu(paso);
            }
            setdesdom(data.desdom);
            settipope(data.tipooperacion);
            setarrtip(data.tipoelec);
            setvalasoc(data.valorasoc);
          }else{
            setlistAlert([
              {
                description: "Debe definir el valor a enviar.",
                type: "alert alert-alert show alert-dismissible fade alert-danger",
                icon: "fas fa-exclamation-circle"
              }
            ]);
          }
        }else{
          setlistAlert([
            {
              description: "Debe seleccionar el tipo de transferencia.",
              type: "alert alert-alert show alert-dismissible fade alert-danger",
              icon: "fas fa-exclamation-circle"
            }
          ]);
        }
      }else{
        setlistAlert([
          {
            description: "Debe registrar una descripción de la asociación.",
            type: "alert alert-alert show alert-dismissible fade alert-danger",
            icon: "fas fa-exclamation-circle"
          }
        ]);
      }
  }

    /*const controlcheck=(id,estado)=>{
      //console.log("id: " + id + " estado: " + estado);
      let copiaestados=[...estadochecks];
      switch(id){
        case "unica":
          if(estado){
            copiaestados[0]=1;
            setcheckactivo(1);
            setcheckunica(true);

          }else{
            copiaestados[0]=0;
            setcheckactivo(0);
            setcheckunica(false);
          }
          break;
        case "diaria":
          if(estado){
            copiaestados[1]=1;
            setcheckactivo(1);
            setcheckdiaria(true);
          }else{
            copiaestados[1]=0;
            setcheckactivo(0);
            setcheckdiaria(false);
          }
          break;
        case "semanal":
          if(estado){
            copiaestados[2]=1;
            setcheckactivo(1);
            setchecksemanal(true);

          }else{
            copiaestados[2]=0;
            setcheckactivo(0);
            setchecksemanal(false);
            
          }
          break;
        case "mensual":
          if(estado){
            copiaestados[3]=1;
            setcheckactivo(1);
            setcheckmensual(true);

          }else{
            copiaestados[3]=0;
            setcheckactivo(0);
            setcheckmensual(false);
          }
          break;
      }
      setestadochecks([...copiaestados])
    }*/
    const controlcheck=(id,estado)=>{
      if(id=="unica" || id=="diaria" || id=="semanal" || id=="mensual"){  
        if(id=="unica"){
          if(estado){
            setcheckdiaria(false);
            setcheckmensual(false);
            setchecksemanal(false);
            console.log("debe cambiar diaria");
          }
          setcheckunica(estado);
       }else if(id=="diaria"){
          if(estado){
            setcheckunica(false);
            setcheckmensual(false);
            setchecksemanal(false);
            console.log("debe cambiar unica");
          }
          setcheckdiaria(estado)
        }else if(id == "semanal"){
          if(estado){
            setcheckmensual(false);
            setcheckunica(false);
            setcheckdiaria(false);
          }
          setchecksemanal(estado);
      
        }else if(id == "mensual"){
          if(estado){
            setchecksemanal(false);
            setcheckdiaria(false);
            setcheckunica(false);
          }
          setcheckmensual(estado);
        }
      } 
    }

    const selecciona=(id)=>{
      console.log(id);
      if (id == 0) {
        setInfoModal(true);
      }else if (id== 1)
      {
        console.log("dia semana asignado"+ weekDay)        
        setInfoPeriodicity(true);
      }
      else if (id== 2)
      { 
        console.log("dia mes asignado" + montDay)       
        setInfoPeriodicityMont(true);
      }
    }
    
    const cambiaFecha=(newFecha)=>{
      console.log("nueva fecha" + newFecha)
      if (newFecha != undefined) {
            let fecha400="";
            if(newFecha.getMonth()+1<10){
                fecha400= newFecha.getFullYear() + "0" + (newFecha.getMonth()+1) +fecha400;
            }else{
                fecha400= newFecha.getFullYear() + "" + (newFecha.getMonth()+1) +fecha400;
            }
            if(newFecha.getDate()<10){
                fecha400=fecha400 + "0" + newFecha.getDate();
            }else{
                fecha400=fecha400 + newFecha.getDate();
            }
            console.log("Estado Modal" + infoModal);
            setfechaselec(fecha400);
            //convertirfecha(fecha400)
            //setmostrar(false);
            //onChange(fecha400);
            setInfoModal(false);
      }
            
    }
    const validacorreo=(correo)=>{
      let correovalido=false;
      let arroba=false;
      let punto=false;
      if(correo.length>0){
        for(let i=0;i<correo.length;i++){
          if(arroba){
            if(correo.substr(i,1)=="."){
              if(correo.substr(i,4)==".com" || correo.substr(i,4)==".gov" || correo.substr(i,4)==".edu"){
                punto=true;
              }
            }
          }else{
            if(correo.substr(i,1)=="@"){
              arroba=true;
            }
          }
        }
      }
      if(arroba && punto){
        return true;
      }else{
        return false;
      }
    }

    const validacheck=()=>{
      if(checkunica){
        return "unica";
      }else if(checkdiaria){
        return "diaria";
      }else if(checksemanal){
        return "semanal";
      }else if(checkmensual){
        return "mensual";
      }else{
        return "";
        //condicionar la creacion si no tiene un check seleccionado
      }

    }

    const validaform=()=>{
      if(desdom.length>0){
        if(tipope.length>0){
          if(valasoc.length>0){
            return true;
          }else{
            setlistAlert([
              {
                description: "Debe definir el valor a enviar.",
                type: "alert alert-alert show alert-dismissible fade alert-danger",
                icon: "fas fa-exclamation-circle"
              }
            ]);
            return false;
          }
        }else{
          setlistAlert([
            {
              description: "Debe seleccionar el tipo de transferencia.",
              type: "alert alert-alert show alert-dismissible fade alert-danger",
              icon: "fas fa-exclamation-circle"
            }
          ]);
          return false;
        }
      }else{
        setlistAlert([
          {
            description: "Debe registrar una descripción de la asociación.",
            type: "alert alert-alert show alert-dismissible fade alert-danger",
            icon: "fas fa-exclamation-circle"
          }
        ]);
        return false;
      }
    }

    const FechaDomiciliacion=(checkeleg)=>{
      let opccheck=validacheck();
      switch(opccheck){
        case "unica":
          if(fechaselec.length>0){
            return(
              <p>{convertirfecha(fechaselec)}</p>
            )
          }else{
            return(
              <Fragment></Fragment>
            )

          }
        break;
        case "diaria":
          if(fechaselec.length>0){
            return(
              <p>{convertirfecha(fechaselec)}</p>
            )
          }else{
            return(
              <Fragment></Fragment>
            )
          }
        break;
        case "semanal":
          switch (weekDay)
          {
            case "L":
              return(
                <p>Lunes día de aplicación </p>
              )        
              break;
            case "M":
              return(
                <p>Martes día de aplicación </p>
              )     
              break;
            case "X":
              return(
                <p>Miercoles día de aplicación </p>
              )       
              break;
            case "J":
              return(
                <p>Jueves día de aplicación </p>
              )           
              break;
            case "V":
              return(
                <p>Viernes día de aplicación </p>
              )          
              break;
            case "S":
              return(
                <p>Sabado día de aplicación </p>
              )        
              break;
            case "D":
              return(
                <p>Domingo día de aplicación </p>
              )      
              break;
            default:
              return(
                <Fragment></Fragment>
              )
          }
          return(
            <p></p>
          )
        break;
        case "mensual":
          if(montDay.length>0){
            return(
              <p>Todos los {montDay}, dia de aplicación</p>
            )
          }else{
            return(
              <Fragment></Fragment>
            )
          }
        break;
        default:
          return(
            <Fragment></Fragment>
          )
      }
    }

    const Botonperiodicidad=(props)=>{
      let tipo=props.tipo;
      let muestra=props.muestra;
      if(muestra){
        switch(tipo){
          case "fecha":
            return(
              <Fragment>
                <BotonEliminaIp eliminarIp={selecciona} index={0} tipo={"domiciliacion"}></BotonEliminaIp>
                <FechaDomiciliacion></FechaDomiciliacion>
              </Fragment>
            )
            break;
          case "semanal":
            return(
              <Fragment>
                <BotonEliminaIp eliminarIp={selecciona} index={1} tipo={"domiciliacion"}></BotonEliminaIp>
                <FechaDomiciliacion></FechaDomiciliacion>
              </Fragment>
            )
            break;
          case "mensual":
            return(
              <Fragment>
                <BotonEliminaIp eliminarIp={selecciona} index={2} tipo={"domiciliacion"}></BotonEliminaIp>
                <FechaDomiciliacion></FechaDomiciliacion>
              </Fragment>
            )
            break;
          default: 
            return(<div></div>);
        }
      }else{
        return(<div></div>);
      } 
    }
    
    
    const creacionasociacion= async()=>{
      //console.log(productOne);
      //console.log(productTwo);
      //operationType:tipope
      let registra=true;
      if(tipoflujo=="modificadomi"){
        let bodyreq={
            associationSecuence: secuencia,
            status: statusdomi,
            commissionCondition: condicioncomision,
            operationType: tipope,
            originSystem: Number(productOne.system),
            originProduct: productOne.accountNumber,
            periodicity: "",
            weekDay: "",
            dayMonthApliaction: "",
            applicationDate: "",
            destinationSystem: 0,
            destinationProduct: "",
            externalAccountSecuenceNumber: "",
            transferValue: valasoc,
            associationDescription: desdom
        }
        if(checkunica){
          bodyreq.periodicity="1";
          if(fechaselec.length>0){
            bodyreq.applicationDate=fechaselec;
          }else{
            setlistAlert([
              {
                description: "Debe definir una fecha de aplicación .",
                type: "alert alert-alert show alert-dismissible fade alert-danger",
                icon: "fas fa-exclamation-circle"
              }
            ]);
            registra=false;
          }
        }else if(checkdiaria){
          bodyreq.periodicity="2";
          if(fechaselec.length>0){
            bodyreq.applicationDate=fechaselec;
          }else{
            setlistAlert([
              {
                description: "Debe definir una fecha de inicio de aplicación .",
                type: "alert alert-alert show alert-dismissible fade alert-danger",
                icon: "fas fa-exclamation-circle"
              }
            ]);
            registra=false;

          }
  
        }else if(checksemanal){
          bodyreq.periodicity="3";
          if(weekDay.length>0){
            bodyreq.weekDay=weekDay;
          }else{
            setlistAlert([
              {
                description: "Debe definir un dia de la semana de aplicación.",
                type: "alert alert-alert show alert-dismissible fade alert-danger",
                icon: "fas fa-exclamation-circle"
              }
            ]);
            registra=false;
          }
          
  
        }else if(checkmensual){
          bodyreq.periodicity="4";
          if(montDay.length>0){
            bodyreq.dayMonthApliaction=montDay;
          }else{
            setlistAlert([
              {
                description: "Debe definir un dia del mes de aplicación.",
                type: "alert alert-alert show alert-dismissible fade alert-danger",
                icon: "fas fa-exclamation-circle"
              }
            ]);
            registra=false;
          }
        }else{
          setlistAlert([
            {
              description: "Debe definir la periodicidad de aplicación.",
              type: "alert alert-alert show alert-dismissible fade alert-danger",
              icon: "fas fa-exclamation-circle"
            }
          ]);
          registra=false;
          //condicionar la creacion si no tiene un check seleccionado
        }

        if(tipoproddesti==1){
          bodyreq.destinationSystem=Number(productTwo.system)
          bodyreq.destinationProduct=productTwo.accountNumber;
  
        }else if(tipoproddesti==2){
          bodyreq.destinationProduct=productTwo.numeroCuenta;
          bodyreq.externalAccountSecuenceNumber=productTwo.sequence;
        }
        console.log(bodyreq);

        if(registra){
          const request= await axiosInstance().put("/WSGYG39_2/api/Domiciliation/UpdateDomiciliation",bodyreq).catch((err) => {
            console.log(err);
            if (err.response.data.errors) {
              setlistAlert(
                err.response.data.errors.map((o) => ({
                  ...o,
                  type: "alert alert-alert show alert-dismissible fade alert-danger",
                  icon: "fas fa-exclamation-circle",
                }))
              );
            } else {
              setlistAlert([
                {
                  description: "No se pudo realizar el registro.",
                  type: "alert alert-alert show alert-dismissible fade alert-danger",
                  icon: "fas fa-exclamation-circle"
                }
              ]);
            }
            return "err";
          });
          console.log(request);
          if (request != "err") {//agregar mensaje de exito dependiendo respuesta 
            
            if (request.data.errors) {
              setlistAlert(
                request.data.errors.map((o) => ({
                  ...o,
                  type: "alert alert-alert show alert-dismissible fade alert-success",
                  icon: "fas fa-check-circle",
                }))
              );
            } else {
              setlistAlert([
                {
                  description: "Operacion exitosa.",
                  type: "alert alert-alert show alert-dismissible fade alert-success",
                  icon: "fas fa-check-circle",
                },
              ]);
            }
            setmaxstepcreaUsu(0); 
            setstepLine(0);
            props.canceladomi("domiciliacion",{
              uniqueIdUser:"modificadomi"
            });
          }
        }
        

      }else{
        let bodyreq={
          status:"1",
          operationType:tipope,
          originSystem: Number(productOne.system),
          originProduct: productOne.accountNumber,
          periodicity: "",
          weekDay: "",
          dayMonthApliaction: "",
          applicationDate: "",
          destinationSystem:0,
          destinationProduct:"",
          externalAccountSecuenceNumber:"",
          transferValue: valasoc,
          associationDescription:desdom
        }
  
        if(checkunica){
          bodyreq.periodicity="1";
          if(fechaselec.length>0){
            bodyreq.applicationDate=fechaselec;
          }else{
            setlistAlert([
              {
                description: "Debe definir una fecha de aplicación .",
                type: "alert alert-alert show alert-dismissible fade alert-danger",
                icon: "fas fa-exclamation-circle"
              }
            ]);
            registra=false;
          }
        }else if(checkdiaria){
          bodyreq.periodicity="2";
          if(fechaselec.length>0){
            bodyreq.applicationDate=fechaselec;
          }else{
            setlistAlert([
              {
                description: "Debe definir una fecha de inicio de aplicación .",
                type: "alert alert-alert show alert-dismissible fade alert-danger",
                icon: "fas fa-exclamation-circle"
              }
            ]);
            registra=false;

          }
  
        }else if(checksemanal){
          bodyreq.periodicity="3";
          if(weekDay.length>0){
            bodyreq.weekDay=weekDay;
          }else{
            setlistAlert([
              {
                description: "Debe definir un dia de la semana de aplicación.",
                type: "alert alert-alert show alert-dismissible fade alert-danger",
                icon: "fas fa-exclamation-circle"
              }
            ]);
            registra=false;
          }
          
  
        }else if(checkmensual){
          bodyreq.periodicity="4";
          if(montDay.length>0){
            bodyreq.dayMonthApliaction=montDay;
          }else{
            setlistAlert([
              {
                description: "Debe definir un dia del mes de aplicación.",
                type: "alert alert-alert show alert-dismissible fade alert-danger",
                icon: "fas fa-exclamation-circle"
              }
            ]);
            registra=false;
          }
        }else{
          setlistAlert([
            {
              description: "Debe definir la periodicidad de aplicación.",
              type: "alert alert-alert show alert-dismissible fade alert-danger",
              icon: "fas fa-exclamation-circle"
            }
          ]);
          registra=false;
          //condicionar la creacion si no tiene un check seleccionado
        }
  
        if(tipoproddesti==1){
          bodyreq.destinationSystem=Number(productTwo.system)
          bodyreq.destinationProduct=productTwo.accountNumber;
  
        }else if(tipoproddesti==2){
          bodyreq.destinationProduct=productTwo.numeroCuenta;
          bodyreq.externalAccountSecuenceNumber=productTwo.sequence;
        }
        console.log(bodyreq);
        
        if(registra){
          const request= await axiosInstance().post("/WSGYG39_2/api/Domiciliation/CreateDomiciliation",bodyreq).catch((err) => {
            console.log(err);
            if (err.response.data.errors) {
              setlistAlert(
                err.response.data.errors.map((o) => ({
                  ...o,
                  type: "alert alert-alert show alert-dismissible fade alert-danger",
                  icon: "fas fa-exclamation-circle",
                }))
              );
            } else {
              setlistAlert([
                {
                  description: "No se pudo realizar el registro.",
                  type: "alert alert-alert show alert-dismissible fade alert-danger",
                  icon: "fas fa-exclamation-circle"
                }
              ]);
            }
            return "err";
          });
          console.log(request);
          if (request != "err") {//agregar mensaje de exito dependiendo respuesta 
            
            if (request.data.errors) {
              setlistAlert(
                request.data.errors.map((o) => ({
                  ...o,
                  type: "alert alert-alert show alert-dismissible fade alert-success",
                  icon: "fas fa-check-circle",
                }))
              );
            } else {
              setlistAlert([
                {
                  description: "Operacion exitosa.",
                  type: "alert alert-alert show alert-dismissible fade alert-success",
                  icon: "fas fa-check-circle",
                },
              ]);
            }
            setmaxstepcreaUsu(0); 
            setstepLine(0);
            props.canceladomi("domiciliacion",{
              uniqueIdUser:"creacion"
            });
          }
        }
        
      }
      
    }
    const Controlproductosdestino=()=>{
      console.log(tipope)
      if(tipope=="1"){
        return(
          <div>
          <Modal
            className="modal-dialog-centered"
            contentClassName="bg-transparent shadow-none"
            isOpen={isLoading}
          >
             
                  <div tabindex="-1" style={{ position: "relative;" ,  "z-index": "1050" ,  display : "block" , width:"100%", height: "80vh" }}>
                        <div style={{ "text-align": "center", top: "50%", position: "relative"  }}>
                            <img style={{height:"100px", }} src={require("../../assets/img/icons/Loader-01.gif").default}></img>
                        </div>
                        <div class="modal-backdrop fade show"></div>
                    </div>
                
          </Modal>
          <Products data={accountsToTransfer} tab={1} isOrigin={false}></Products>
          </div>              
        )
      }else if(tipope=="2"){
        return(
          <Fragment>
            <Modal
              className="modal-dialog-centered"
              contentClassName="bg-transparent shadow-none"
              isOpen={isLoading}
            >
              
                    <div tabindex="-1" style={{ position: "relative;" ,  "z-index": "1050" ,  display : "block" , width:"100%", height: "80vh" }}>
                          <div style={{ "text-align": "center", top: "50%", position: "relative"  }}>
                              <img style={{height:"100px", }} src={require("../../assets/img/icons/Loader-01.gif").default}></img>
                          </div>
                          <div class="modal-backdrop fade show"></div>
                      </div>
            </Modal>
            <div className="text-center m-4">
                <h2 class="ml-2"> Elige una cuenta asociada </h2>
            </div>
            <RelatedAccounts data={relatedAccounts}></RelatedAccounts> 
          </Fragment>
        )
      }else if(tipope=="3"){
        return(
          <Fragment>
            <Modal
              className="modal-dialog-centered"
              contentClassName="bg-transparent shadow-none"
              isOpen={isLoading}
            >
                    <div tabindex="-1" style={{ position: "relative;" ,  "z-index": "1050" ,  display : "block" , width:"100%", height: "80vh" }}>
                          <div style={{ "text-align": "center", top: "50%", position: "relative"  }}>
                              <img style={{height:"100px", }} src={require("../../assets/img/icons/Loader-01.gif").default}></img>
                          </div>
                          <div class="modal-backdrop fade show"></div>
                      </div>
            </Modal>
            <Products data={relatedAccounts} tab={1} isOrigin={false}></Products>         
          </Fragment>
        )
      }
      else{
        return(<Fragment></Fragment>)

      }
    }
    const quitaalertas=()=>{
      if(listAlert.length>0){
        setlistAlert([]);
      }
    }
    

    return(
        <div className="anchosteper">
            <div style={{display:"flex", justifyContent:"center", alignItems:"center"}}>
                <button className="btn-icon bg-white text-green btn" onClick={()=>{cancelaUsuCM();dispatch(cambiaruta("Inicio/Seguridad/Domiciliación"))}}>Cancelar</button>
            </div>

            <DivStepper
            step={stepLine}
            listStep={listStepLine}
            type={"line"}
            >
                <DivStep>
                    <Formetapa1 data={{des:desdom,tipop:tipope,arrtipos:arrtip,valasoc:valasoc}} funcionpadre={AvanzaStepform} quitaalertas={quitaalertas}></Formetapa1>
                    <Alerts data={listAlert}></Alerts>
                </DivStep>
                <DivStep>
                    <Products data={accounts} tab={1} isOrigin={true}></Products>
                </DivStep>
                
                <DivStep>
                    <Controlproductosdestino></Controlproductosdestino>
                    <Alerts data={listAlert}></Alerts>
                </DivStep>
                <DivStep>
                  <h4 className="justify-content ml-auto mr-auto" style={{width:"50%", margin:"4px 4px 4px 4px"}}>Define con qué periodicidad se realizaría la asociación.
                      Puedes seleccionar la opción que se ajuste a tu necesidad. </h4>
                      <div style={{margin:"3px 0px 19px 200px", display:"flex",flexDirection:"column", width:"50%"}}>
                        <div>
                          <Checksantader mensaje={"Única: Se realizaría una sola vez en la fecha que selecciones."} funcionpadre={controlcheck} idCheck={"unica"} estadocheck={checkunica} permisocambio={!checkunica}></Checksantader>
                          <div style={{margin:"0px 0px 5px 30px"}}>
                            <Botonperiodicidad tipo={"fecha"} muestra={checkunica}></Botonperiodicidad>
                          </div>
                        </div>
                        <div>
                          <Checksantader mensaje={"Diaria: Elije la fecha en que empieza la asociación."} funcionpadre={controlcheck} idCheck={"diaria"} estadocheck={checkdiaria} permisocambio={!checkdiaria}></Checksantader> 
                          <div style={{margin:"0px 0px 5px 30px"}}>
                            <Botonperiodicidad tipo={"fecha"} muestra={checkdiaria}></Botonperiodicidad>
                          </div>
                        </div>
                        <div>
                          <Checksantader mensaje={"Semanal: Elije el día de la semana en que se realizaría la asociación."} funcionpadre={controlcheck} idCheck={"semanal"} estadocheck={checksemanal} permisocambio={!checksemanal}></Checksantader>
                          <div style={{margin:"0px 0px 5px 30px"}}>
                            <Botonperiodicidad tipo={"semanal"} muestra={checksemanal}></Botonperiodicidad>
                          </div>
                        </div>
                        <div>
                          <Checksantader mensaje={"Mensual: Elije el día del mes en que se realizaría la asociacion."} funcionpadre={controlcheck} idCheck={"mensual"} estadocheck={checkmensual} permisocambio={!checkmensual}></Checksantader>              
                          <div style={{margin:"0px 0px 5px 30px"}}>
                            <Botonperiodicidad tipo={"mensual"} muestra={checkmensual}></Botonperiodicidad>
                          </div>
                          
                        </div>
                      </div>
                
                    <button
                        className="bg-green text-white btn shadow btn-rounded btn-block mb-3 ml-auto mr-auto"
                        style={{width:"40%"}}
                        onClick={()=>{
                          creacionasociacion();
                        }}
                    >
                        Finalizar 
                    </button>
                    <Alerts data={listAlert}></Alerts>
                    <Modal
                      className="modal-dialog-centered"
                      contentClassName=""
                      isOpen={infoModal}
                      toggle={() => setInfoModal(!infoModal)}
                    >
                        <div className="p-4">
                          <div class="my-modal-header">
                            <div class="header-title">
                            <CalendarioNuevo title={"Fecha de aplicación"} muestra={mostrar} cambio={cambiaFecha} className="col-auto"></CalendarioNuevo>
                            </div>
                            {/* <div className="mt-4">
                              <Link class="btn-icon text-green btn" href="/Formato de Transacciones Masivas.xlsm">
                                <span class="btn-inner--icon">
                                  <i class="far fa-question-circle"></i>
                                </span>
                                <span class="btn-inner--text">Ayuda</span>
                              </Link>
                            </div> */}
                          </div>
                        </div>
                      </Modal>
                      <Modal
                      className="modal-dialog-centered"
                      contentClassName=""
                      isOpen={infoPeriodicity}
                      toggle={() => setInfoPeriodicity(!infoPeriodicity)}
                    >
                        <div className="p-4">
                          <div class="my-modal-header">
                            <div class="header-title">
                            <Cuadricula elements={"Lun,Mar,Mie,Jue,Vie,Sab,Dom"} title={"Día aplicación"} muestra={mostrar} asigna={asignafecha} className="col-auto"></Cuadricula>
                            </div>                            
                          </div>
                        </div>
                      </Modal>
                      <Modal
                      className="modal-dialog-centered"
                      contentClassName=""
                      isOpen={infoPeriodicityMont}
                      toggle={() => setInfoPeriodicityMont(!infoPeriodicityMont)}
                    >
                        <div className="p-4">
                          <div class="my-modal-header">
                            <div class="header-title">
                            <Cuadricula elements={"1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31"} title={"Día aplicación"} muestra={mostrar} asigna={asignafechames} className="col-auto"></Cuadricula>
                            </div>                            
                          </div>
                        </div>
                      </Modal>
                </DivStep>
            </DivStepper>
        </div>

    );
}


export default Domiciliacion;